import Header from '../../../ui-components/Header';
import useGiftcardUspBannerEntries from '../server-data/use-giftcard-usp-banner-entries';

const HeaderWithData = () => {
  const { data: uspBannerEntries } = useGiftcardUspBannerEntries();

  return <Header uspBannerEntries={uspBannerEntries} />;
};

export default HeaderWithData;
